var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../typings/tsd.d.ts" />
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var EsriMapService = /** @class */ (function (_super) {
            __extends(EsriMapService, _super);
            function EsriMapService(injectedBreeze, $http, $q) {
                var _this = _super.call(this, injectedBreeze, $q) || this;
                _this.$http = $http;
                return _this;
            }
            EsriMapService.prototype.loadLayerMetadata = function (layer, esrilayer) {
                var _this = this;
                var d = this.$q.defer();
                var url = this.getProxyUrl(this.getUrlEscaped(layer.url) + esrilayer.layerId, layer.proxyUrl);
                this.$http.post('/proxy', url).then(function (r) {
                    var data = r.data;
                    esrilayer.description = data.description;
                    data.fields.forEach(function (f) {
                        var field = _this.createEsriFieldMetadata();
                        field.name = f.name;
                        field.alias = f.alias;
                        field.type = _this.getVariableType(f.type);
                        field.length = f.length;
                        esrilayer.fields.push(field);
                    });
                    d.resolve();
                });
                return d.promise;
            };
            EsriMapService.prototype.getFeatureGeometry = function (feature, geometryType) {
                switch (geometryType) {
                    case "esriGeometryPolygon":
                        return feature.geometry.rings;
                    case "esriGeometryPolyline":
                        return feature.geometry.paths;
                    case "esriGeometryPoint":
                        return [feature.geometry.x, feature.geometry.y];
                    default:
                        return null;
                }
            };
            EsriMapService.prototype.createMarker = function (feature, geometryType, options) {
                switch (geometryType) {
                    case "esriGeometryPoint":
                        return L.marker(this.getFeatureGeometry(feature, geometryType), options);
                    default:
                        return null;
                }
            };
            EsriMapService.prototype.createGeoJsonLayer = function (feature, geometryType, options) {
                var geoJson = Terraformer.ArcGIS.parse(feature.geometry);
                return L.geoJSON(geoJson, options);
            };
            EsriMapService.prototype.createVectorLayer = function (feature, geometryType, options) {
                switch (geometryType) {
                    case "esriGeometryPolygon":
                        return L.polygon(this.getFeatureGeometry(feature, geometryType), options);
                    case "esriGeometryPolyline":
                        return L.polyline(this.getFeatureGeometry(feature, geometryType), options);
                        ;
                    default:
                        return null;
                }
            };
            EsriMapService.prototype.getVariableType = function (esriType) {
                switch (esriType) {
                    case "esriFieldTypeDouble":
                        return 2 /* Decimal */;
                    case "esriFieldTypeOID":
                    case "esriFieldTypeString":
                        return 0 /* String */;
                    case "esriFieldTypeGeometry":
                        return 81 /* Geometry */;
                    default:
                        return 0 /* String */;
                }
            };
            EsriMapService.prototype.getUrlEscaped = function (url) {
                if (url.charAt(url.length - 1) != '/') {
                    return url + '/';
                }
                return url;
            };
            EsriMapService.prototype.getProxyUrl = function (url, proxyUrl, useAnd) {
                var combinedUrl = "";
                if (proxyUrl) {
                    combinedUrl = proxyUrl + "?" + url;
                }
                if (useAnd) {
                    return combinedUrl + "&f=pjson";
                }
                return combinedUrl + "?f=pjson";
            };
            EsriMapService.prototype.getMapServiceMetadata = function (url, proxy) {
                var _this = this;
                var d = this.$q.defer();
                var combinedUrl = this.getProxyUrl(url, proxy);
                this.$http.post('/proxy', combinedUrl).then(function (r) {
                    var data = r.data;
                    var metaData = _this.createEsriMapServiceMetadata();
                    metaData.currentVersion = data.currentVersion;
                    metaData.name = data.name;
                    metaData.description = data.description;
                    var splitCapabilities = data.capabilities.split(',');
                    splitCapabilities.forEach(function (c) {
                        var newCapability = _this.createEsriMapServiceCapability(c);
                        if (newCapability) {
                            metaData.capabilities.push(newCapability);
                        }
                    });
                    data.layers.forEach(function (l) {
                        var newLayer = _this.createEsriMapServiceLayerMetadata();
                        newLayer.layerId = l.id;
                        newLayer.parentLayerId = l.parentLayerId >= 0 ? l.parentLayerId : null;
                        newLayer.name = l.name;
                        metaData.layers.push(newLayer);
                    });
                    d.resolve(metaData);
                });
                return d.promise;
            };
            EsriMapService.prototype.createEsriMapServiceMetadata = function () {
                return this.createNewEntity("EsriMapServiceMetadata");
            };
            EsriMapService.prototype.createEsriFieldMetadata = function () {
                return this.createNewEntity("EsriField");
            };
            EsriMapService.prototype.createEsriMapServiceCapability = function (value) {
                var capabilityType;
                switch (value) {
                    case "Map":
                        capabilityType = 1 /* Map */;
                        break;
                    case "Query":
                        capabilityType = 2 /* Query */;
                        break;
                    default:
                        return null;
                }
                var capability = this.createNewEntity("EsriMapServiceCapability");
                capability.capability = capabilityType;
                return capability;
            };
            EsriMapService.prototype.createEsriMapServiceLayerMetadata = function () {
                return this.createNewEntity("EsriMapServiceLayerMetadata");
            };
            EsriMapService.prototype.getGeometryType = function (geoJsonType) {
                switch (geoJsonType) {
                    case "LineString":
                        return "esriGeometryPolyline";
                    case "Point":
                        return "esriGeometryPoint";
                    case "Polygon":
                        return "esriGeometryPolygon";
                    default:
                        return "esriGeometryPolygon";
                }
            };
            EsriMapService.prototype.getSpatialRelationship = function (geoJsonType) {
                switch (geoJsonType) {
                    // case "LineString":
                    //   return "esriSpatialRelEnvelopeIntersects";
                    default:
                        return "esriSpatialRelIntersects";
                }
            };
            EsriMapService.prototype.queryMapService = function (esriQuery, placeholderValueDictionary, geometryPlaceholder) {
                var d = this.$q.defer();
                var baseUrl = esriQuery.layer.url.endsWith('/') ? esriQuery.layer.url : esriQuery.layer.url + '/';
                baseUrl = baseUrl + esriQuery.esriMapServiceLayerMetadata.layerId + '/query?';
                var urlParams = "";
                var whereClause = this.getWhereClause(esriQuery, placeholderValueDictionary);
                if (whereClause) {
                    urlParams += 'WHERE=' + whereClause;
                }
                if (esriQuery.includeGeometryFilter) {
                    urlParams += "&inSR={wkid:4326}";
                    if (esriQuery.geometryFilter.useMapGeometry) {
                        var bounds = warsApp.directives.GisMapController.currentMap.getBounds();
                        urlParams += "&geometry=" +
                            JSON.stringify({
                                "xmin": bounds.getWest(),
                                "ymin": bounds.getSouth(),
                                "xmax": bounds.getEast(),
                                "ymax": bounds.getNorth(),
                                "spatialReference": { "wkid": 4326 }
                            });
                        urlParams += "&geometryType=esriGeometryEnvelope";
                    }
                    else if (geometryPlaceholder) {
                        var geo = null;
                        if (geometryPlaceholder.type) {
                            geo = geometryPlaceholder;
                        }
                        else {
                            geo = geometryPlaceholder.toGeoJSON();
                            if (geo && geo.geometry.type === "LineString" && geo.geometry.coordinates.length === 2) {
                                geo = turf.buffer(geo.geometry, 25, 'meters');
                            }
                        }
                        var convertedGeo = Terraformer.ArcGIS.convert(geo).geometry;
                        delete convertedGeo.spatialReference;
                        urlParams += "&geometry=" + JSON.stringify(convertedGeo);
                        urlParams += "&geometryType=" + this.getGeometryType(geo.geometry.type);
                        urlParams += "&spatialRel=" + this.getSpatialRelationship(geo.geometry.type);
                    }
                }
                urlParams += "&ReturnGeometry=";
                if (esriQuery.returnGeometry) {
                    urlParams += "true&outSR={wkid:4326}";
                }
                else {
                    urlParams += "false";
                }
                urlParams += "&outFields=*";
                var combinedUrl = this.getProxyUrl(baseUrl + urlParams, esriQuery.layer.proxyUrl, true);
                this.$http.post('/proxy', combinedUrl).then(function (r) {
                    var data = r.data;
                    var featureCollection = {
                        type: "FeatureCollection",
                        features: []
                    };
                    if (data && data.features) {
                        data.features.forEach(function (f) {
                            var feature = Terraformer.ArcGIS.parse(f);
                            feature.id = services.UtilityService.generateGuidComb();
                            featureCollection.features.push(feature);
                        });
                    }
                    d.resolve(featureCollection);
                });
                return d.promise;
            };
            EsriMapService.prototype.getWhereClause = function (esriQuery, placeholderValueDictionary) {
                var whereStr = "";
                if (esriQuery.whereClause) {
                    return esriQuery.whereClause;
                }
                if (esriQuery.wherePredicates) {
                    for (var i = 0; i < esriQuery.wherePredicates.length; i++) {
                        var predicate = esriQuery.wherePredicates[i];
                        var isString = predicate.field.type == 0 /* String */;
                        if (i != 0) {
                            if (esriQuery.useOrForWheres) {
                                whereStr += " OR ";
                            }
                            else {
                                whereStr += " AND ";
                            }
                        }
                        if (isString) {
                            whereStr += 'UPPER(' + predicate.field.name + ')';
                        }
                        else {
                            whereStr += predicate.field.name;
                        }
                        whereStr += this.getOperator(predicate.compareOperator);
                        if (isString) {
                            whereStr += "UPPER('";
                        }
                        var val = '';
                        if (predicate.isPlaceholder) {
                            val = placeholderValueDictionary[predicate.placeHolderUniqueIdentifier];
                        }
                        else if (predicate.value) {
                            val = predicate.value;
                        }
                        else {
                            val = '';
                        }
                        if (predicate.javascriptTransformer) {
                            var args = ['value', predicate.javascriptTransformer.code];
                            var myFunc = Function.apply(null, args);
                            var funcResult = myFunc(val);
                            whereStr += funcResult;
                        }
                        else {
                            whereStr += val;
                        }
                        if (isString) {
                            whereStr += "')";
                        }
                    }
                }
                return whereStr;
            };
            EsriMapService.prototype.getOperator = function (comparisionType) {
                switch (comparisionType) {
                    case 0 /* Equals */:
                        return "=";
                    case 2 /* GreaterThan */:
                        return ">";
                    case 4 /* GreaterThanOrEqualTo */:
                        return ">=";
                    case 3 /* LessThan */:
                        return "<";
                    case 5 /* LessThanOrEqualTo */:
                        return "<=";
                    case 1 /* NotEquals */:
                        return "<>";
                    default:
                        return "=";
                }
            };
            return EsriMapService;
        }(services.DataService));
        services.EsriMapService = EsriMapService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('EsriMapService', ['breeze', '$http', '$q']);
